import React from "react";
import { useTheme } from "@/lib/theme";

export default function PaletteFooter() {
  const { showFooter, current } = useTheme();
  if (!showFooter || !current) return null;
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] border-t flex items-center gap-3 px-4 py-1.5 text-[11px]"
      style={{ background: "var(--surface)", borderColor: "var(--border)", color: "var(--text-muted)", fontFamily: current.fontMono || "ui-monospace, monospace" }}
      data-testid="palette-footer"
    >
      <span style={{ color: "var(--text)", fontWeight: 700 }}>{current.name}</span>
      <div className="flex items-center gap-2 overflow-x-auto">
        {current.swatches.map((s) => (
          <div key={s.label} className="inline-flex items-center gap-1.5 whitespace-nowrap">
            <span
              className="inline-block w-3 h-3 rounded"
              style={{ background: s.value, border: "1px solid var(--border)" }}
            />
            <span>{s.label}</span>
            <span style={{ color: "var(--text)" }}>{s.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
